"use strict";
angular.module("internal.exams").controller("InternalExamType", ["$scope",
    "$state",
    "EXType",
    "EXAutoNum",
    "TGTriggerGroups",
    "TGTriggers",
    "$stateParams",
    "$window",
    function ($scope, $state, EXType, EXAutoNum, TGTriggerGroups, TGTriggers, $stateParams, $window) {
        $scope.loading = true;
        $scope.AutoNumberOptions = [];
        $scope.Type = { activeStatus: true };
        $scope.examTypeID = $stateParams.examTypeID;
        $scope.saveMessage = $stateParams.saveMessage;
        $scope.configuration = { infiniteFound: false };
        $scope.groups = [];
        $window.scrollTo(0, 0);

        if ($stateParams.examTypeID != null) {
            EXType.gettype($stateParams.examTypeID).then(function (Type) {
                $scope.typeEditHistory = {
                    createdby: Type.createdByUserSummary.fullName,
                    modifiedby: Type.modifiedByUserSummary.fullName,
                    createdon: Type.createdOnUtc,
                    modifiedon: Type.modifiedOnUtc
                };
                $scope.Type = Type;
                $scope.loading = false;
                TGTriggerGroups.getConfiguration("Exams", $scope.Type.triggerConfigurationID).then(function (groups) {
                    $scope.groups = groups;
                    $scope.loading = false;
                });
            });
        }
        EXAutoNum.getActiveAutoNums().then(function (AutoNum) {
            AutoNum.records.forEach(function (AutoNum) {
                AutoNum.name = AutoNum.formatName;
                $scope.AutoNumberOptions.push({
                    name: AutoNum.formatName,
                    id: AutoNum.id
                });
            })
        });
        $scope.save = function () {
            $scope.saving = true;
            if (!$scope.Type.autoNumber) {
                $scope.Type.autoNumber = {}
            }
            $scope.Type.autoNumber.id = $scope.Type.autoNumberId; // Needed on update / put
            EXType.save($scope.Type).then(function (Type) {
                $scope.saving = false;
                if (Type != null) {
                    $state.go("internal.exams.administrative.type", { examTypeID: Type.id, saveMessage: "Record updated successfully" });
                } else {
                    $scope.saveMessage = "Error: Save failed";
                    $window.scrollTo(0, 0);
                }
            });
        };
        $scope.delete = function () {
            if ($scope.Type.sessionCount != null && $scope.Type.sessionCount > 0) {
                $scope.saveMessage = "Please re-assign the associated exam session(s) to a different Type in order for deletion";
                $window.scrollTo(0, 0);
            } else {
                $scope.deleting = true;
                if (window.confirm("Are you sure you want to delete this exam type?")) {
                    EXType.delete($scope.Type.id).then(function () {
                        $scope.deleting = false;
                        $state.go("internal.exams.administrative.types", {}, {
                            reload: "internal.exams.administrative.types"
                        });
                    });
                } else {
                    $scope.deleting = false;
                }
            }
        };
        $scope.resetActions = function (trigger) {
            trigger.edit = false;
            trigger.trigger_action_values = angular.copy(trigger.previous_actions);
        };
        $scope.saveTrigger = function (trigger, trigger_object_id) {
            trigger.saving = true;
            TGTriggers.save(trigger, trigger_object_id, $scope.examTypeID).then(function () {
                trigger.previous_actions = angular.copy(trigger.trigger_action_values);
                trigger.saving = false;
                trigger.edit = false;
            });
        };
        $scope.actionOptions = function (trigger, objectTrigger) {
            return {
                containment: "#trigger_" + (objectTrigger ? trigger.trigger_object_id : trigger.id),
                scrollableContainer: "#trigger_" + (objectTrigger ? trigger.trigger_object_id : trigger.id),
                containerPositioning: "relative",
                accept: function (sourceItemHandleScope, destSortableScope) {
                    return (sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id);
                },
                orderChanged: function (event) {
                    trigger.edit = true;
                }
            };
        };
    }]);